import { render } from "./KtbYieldBandChart.vue?vue&type=template&id=06ec8082"
import script from "./KtbYieldBandChart.vue?vue&type=script&lang=js"
export * from "./KtbYieldBandChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__